<template>
  <div class="preview-page">
    <div class="head-image no-margin"
         :style="
        form.imgsCut? { 'background': `url(${form.imgsCut}) no-repeat center/cover` }
          : form.imgs
          ? { 'background': `url(${form.imgs}) no-repeat center/cover` }
          : {
              'background': `url(${importTransform()}) no-repeat center/cover`
            }
      "></div>
    <div class="head-white-area">
      <div class="head-container">
        <div class="title-bar">
          <div class="avatar"
               :style="
              form.avatar
                ? { 'background-image': `url(${form.avatar})` }
                : { 'background-image': `url(${importTransform2()})` }
            "></div>
          <div class="title-content">
            <p class="title"
               :title="form.name">
              {{
                form.name && form.name.length > 20
                  ? `${form.name.slice(0, 20)}...`
                  : form.name
              }}
            </p>
            <p class="author">
              <span class="author-info name">{{
                form.nickName
                  ? form.nickName
                  : `用户${form.userId}`
              }}</span>
              <span class="author-info time">发表时间：{{ form.updateTime | formatTime }}</span>
            </p>
          </div>
          <div class="collect-area">
            <div class="want"
                 @click="isHeart">
              <span class="icon"
                    :style="
                  have == 0 || have == undefined
                    ? { 'background-image': `url(${heartOutLine})` }
                    : { 'background-image': `url(${heart})` }
                "></span>
              <span class="text">我想去</span>
            </div>
            <div class="people-want">{{ `已被${wantNum}人标记为我想去` }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="travel-container">
      <div class="travel-info">
        <template v-for="(items, index) in form.nodeList"
                  style="position: relative">
          <div class="info-level2"
               :ref="'node' + index"
               :key="`level-2-${index}`">
            <div class="info-content-level2">
              <div class="title-level2">
                <p class="monitorTarget">{{ items.name }}</p>
              </div>
              <template v-for="(itemschild, j) in items.paragraphList">
                <div class="info-content-level3"
                     :ref="'nodechild' + index + j"
                     :key="`level-3-${j}`">
                  <div class="level3-title"
                       v-if="itemschild.name">
                    <span class="icon-span"
                          :style="{
                        'background-image': `url(${imageMapping(
                          itemschild.name
                        )}`
                      }"></span>
                    <span class="text-span monitorTarget">{{
                      itemschild.name
                    }}</span>
                  </div>
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="level3-content"
                         :key="`level-4-${z}`">
                      <div v-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <img v-if="itemschildchild.content"
                               :src="itemschildchild.content" />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video v-if="itemschildchild.content"
                                 controls="controls"
                                 :src="itemschildchild.content"></video>
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <!-- 这种连着写的方式可以防止首行多余空格 -->
                          <p style="line-height:2em">{{ itemschildchild.content }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
        <div class="text-over">
          <div class="text-over-icon">
            <svg-icon iconClass="endText"
                      class="text-over-img"></svg-icon>
            <span class="text-over-text over-top-text">本篇完</span>
          </div>
          <div class="text-over-line"></div>
          <div class="text-over-text">自驾游，上鹿驾，出游更轻松！</div>
        </div>
        <!-- 发表评论区域 -->
        <template v-if="this.$cookie.get('userInfo_userId')">
          <div class="comment-container">
            <div class="comment-user"
                 :style="
                userdetailList.avatar
                  ? { 'background-image': `url(${userdetailList.avatar})` }
                  : { 'background-image': `url(${headAvatar})` }
              "></div>
            <el-input class="comment-content"
                      type="textarea"
                      :rows="8"
                      placeholder="友善的评论，良性的表达，用发现美的眼睛看世界。"
                      v-model="commentText"
                      maxlength="512"
                      show-word-limit></el-input>
          </div>
          <div class="comment-button-container">
            <span v-if="showTipText"
                  class="show-tip-text">说点儿什么再发表吧</span>
            <el-button type="primary"
                       @click="releaseComment">发表评论</el-button>
          </div>
        </template>
        <!-- 热门评论区域 -->
        <div class="comment-hot-container"
             v-if="hotCommentList.length > 0">
          <div class="comment-hot-button">
            <div class="comment-hot-text">热门评论</div>
          </div>
          <div class="comment-card-container">
            <comment-card ref="comment"
                          class="comment-total-list"
                          :List="hotCommentList"
                          @isreply="isreply"
                          @commentDelete="commentDelete"
                          @toggleLike="changeLike"
                          @replyRelease="replyRelease"></comment-card>
          </div>
        </div>
        <template v-if="contentShow">
          <!-- 所有评论分割线 -->
          <line-between class="all-comment-split"
                        style="margin-left:20px"
                        :lineText="'所有评论'"
                        :customWidth="'42%'"></line-between>
          <!-- 所有评论列表 -->
          <div class="infinite-list">
            <comment-card ref="comment"
                          class="comment-total-list"
                          :List="totalCommentList"
                          @isreply="isreply"
                          @commentDelete="commentDelete"
                          @toggleLike="changeLike"
                          @replyRelease="replyRelease"></comment-card>
          </div>
          <!-- 无限滚动的加载 -->
          <div v-loading="infiniteLoading"
               v-show="infiniteLoading"
               ref="loading"
               class="comment-loading"></div>
          <!-- 全部评论已读 -->
          <line-between class="all-comment-read"
                        v-if="showAllHasRead"
                        :lineText="'全部评论已读'"
                        :customWidth="'12%'"></line-between>
        </template>
      </div>
      <div class="travel-navi">
        <div class="travel-navi-info">
          <p>
            <span>
              <img src="~@/assets/images/preview/traveldate.png" />
            </span>
            <span>
              开始日期：{{
                form.beginDate ? form.beginDate : "--" | formatTime
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/playway.png" />
            </span>
            <span>
              玩法：{{
                form.playTypeIdList ? form.playTypeIdList : "--" | getplayWay
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/partner.png" />
            </span>
            <span>和谁去：{{
                form.tourPar ? form.tourPar : "--" | gettourPar
              }}</span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/days.png" />
            </span>
            <span>游玩天数：{{ form.playDays ? `${form.playDays}天` : "--" }}</span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/totalMileage.png" />
            </span>
            <span>
              总里程数：{{
                form.totalMileage ? `${form.totalMileage}公里` : "--"
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/icons/icon-drive-difficulty-colorful.png" />
            </span>
            <span>
              驾驶难度：{{
                form.difficulty ? form.difficulty : "--" | getdifficulty
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/icons/icon-expenditure-colorful.png" />
            </span>
            <span>人均消费：{{ form.price ? `${form.price}元` : "--" }}</span>
          </p>
        </div>
        <div class="travel-navi-content"
             :style="tNaviStyle"
             ref="tNavi">
          <div class="navi-title">
            <p>目录导航</p>
          </div>
          <div class="navi-content no-shadow">
            <div class="navi-content-area">
              <el-scrollbar style="height:100%"
                            ref="elscrollbar">
                <template v-for="(items, index) in form.nodeList">
                  <div class="navi-item naviTarget"
                       v-if="items.name"
                       :key="`navi-${index}`">
                    <p class="left-line">
                      <span class="thin-line line-top"></span>
                      <span class="small-point"
                            :class="naviChecked == index ? 'checked-ball' : ''"></span>
                      <span class="thin-line line-bottom"></span>
                    </p>
                    <p class="item-text level2-navi-item"
                       :class="naviChecked == index ? 'checked-text' : ''"
                       @click="nodeClick($event, items, index)">
                      {{ items.name }}
                    </p>
                  </div>
                  <template v-for="(itemschild, j) in items.paragraphList">
                    <div class="navi-item naviTarget"
                         v-if="itemschild.name && itemschild.name !== ''"
                         :key="`navi-line-${index}-${j}`">
                      <p class="left-line">
                        <span class="thin-line line-top"></span>
                        <span class="small-point"
                              :class="
                            naviChildChecked == `${index}${j}`
                              ? 'checked-ball'
                              : ''
                          "></span>
                        <span class="thin-line line-bottom"></span>
                      </p>
                      <p class="item-text level3-navi-item"
                         :class="
                          naviChildChecked == `${index}${j}`
                            ? 'checked-text'
                            : ''
                        "
                         @click="nodechildClick($event, index, j)">
                        {{ itemschild.name }}
                      </p>
                    </div>
                  </template>
                </template>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>
      <!-- 返回到顶部 -->
      <div class="back-top iconfont iconfanhuidingbu"
           v-if="showReturnTop"
           :style="{
          bottom: this.returnTopBottomValue,
          left: this.returnTopLeftValue
        }"
           ref="returnTop"
           @click="returnToTop">
      </div>
      <div class="user-feedback iconfont iconliuyanfankui"
           v-if="showReturnTop"
           :style="{
          bottom: this.useFeedbackValue,
          left: this.feedbackTopLeftValue
        }"
           @click="userFeedback">
      </div>
      <el-dialog class="user-feedback-dialog"
                 title="说出你的想法"
                 :visible.sync="userFeedbackVisible"
                 width="780px">
        <el-input type="textarea"
                  maxlength="400"
                  show-word-limit
                  placeholder="成长总要经历磨砺，感谢你选择了我们，并且帮助成就了我们，欢迎你提出更多宝贵的想法，我们会不定期反馈并送出精美小礼物，比心~"
                  v-model="feedbackContent">
        </el-input>
        <span slot="footer"
              class="dialog-footer">
          <el-button type="primary"
                     @click="userFeedbackonClick">发 送</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import api from "../../axios/api";
import Global from "../../utils/Global";
import service from "../../axios/service/service";
import heartOutLine from "@/assets/images/icons/icon-heart-outline.png";
import heart from "@/assets/images/icons/icon-heart.png";
import { commonFilter } from "./commonFilter.js";
import CommentCard from "@/components/comment/CommentCard";
import LineBetween from "@/components/comment/LineBetween";
import {
  saveComment,
  queryComment,
  adoptComment,
  replyComment,
  removeComment,
  filterComment,
  saveFeedback
} from "@/axios/service/travel";
import headAvatar from "@/assets/images/avatar.png";
// import travelMixin from "@/mixins";
export default {
  components: {
    CommentCard,
    LineBetween
  },
  mixins: [{ ...commonFilter }],
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
  },
  data () {
    return {
      endTextIcon: require("@/assets/svg/endText.svg"),
      lastTotal: "", //上次搜索的评论总数
      returnTopBottomValue: "",
      useFeedbackValue: "",
      returnTopStyle: {}, //返回到顶部的按钮样式
      showReturnTop: false, //返回顶部按钮
      useFeedback: false, //返回顶部按钮
      headAvatar: headAvatar, //用户默认头像
      hasTriggerInfinate: false,
      stopSrearchAllList: false,
      scrollDisabled: false, //是否允许无限滚动
      contentShow: false,
      originRows: 20, //初始行数
      originPage: 1, //初始页数
      infiniteLoading: false,
      showAllHasRead: false, //展示所有已读
      showTipText: false, //没有输入评论内容的提示文字
      commentText: "",
      totalCommentList: [], //全部评论
      hotCommentList: [], //热门评论
      returnTopLeftValue: "",
      feedbackTopLeftValue: "",
      tNaviStyle: {},
      imageUrl: "",
      collapse: false,
      form: {},
      id: "",
      naviChecked: "",
      naviChildChecked: "",
      heart: heart,
      heartOutLine: heartOutLine,
      imageOfType: {
        穿衣指南: require("@/assets/images/icons/type/dressing.png"),
        注意事项: require("@/assets/images/icons/type/attention.png"),
        温馨提示: require("@/assets/images/icons/type/hint.png"),
        避坑秘籍: require("@/assets/images/icons/type/cheats.png"),
        民族风俗: require("@/assets/images/icons/type/custom.png"),
        禁忌: require("@/assets/images/icons/type/taboo.png"),
        必备物品: require("@/assets/images/icons/type/must.png"),
        剁手清单: require("@/assets/images/icons/type/listing.png"),
        交通: require("@/assets/images/icons/type/traffic.png"),
        美食推荐: require("@/assets/images/icons/type/cate.png"),
        节日: require("@/assets/images/icons/type/festival.png"),
        不能错过: require("@/assets/images/icons/type/cannotmiss.png")
      },
      userFeedbackVisible: false,
      userFeedbackTextarea: "",
      userId: "",
      feedbackContent: "",
      obj: {},
      list: []
    };
  },
  watch: {
    "form.name" (value) {
      if (value) {
        document.title = `${value}_自驾出游好帮手_鹿驾网`;
        //form的值改变调用查询评论的接口
        this.queryComment({
          type: 1, //查询全部评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: this.hasTriggerInfinate ? this.originRows : 10, //是否出发过无限滚动，如果触发无限滚动则查询无限滚动那么多数据
          page: 1,
          userId: this.$cookie.get("userInfo_userId")
        });
        this.queryComment({
          type: 2, //查询热门评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: 3, //查询top3的热门评论
          page: 1,
          userId: this.$cookie.get("userInfo_userId")
        });
      }
    },
    findtreveldetail (value) {
      this.form = value[0];
    },
    commentText (value) {
      // 如果评论输入内容不为空则隐藏必填提示文字
      if (value) {
        this.showTipText = false;
      }
    },
    hotCommentList (value) {
      if (value.length !== 0) {
        for (let i in value) {
          this.$set(value[i], "isreply", false);
          this.$set(value[i], "ishot", 1);
          for (let j in value[i].replys) {
            this.$set(value[i].replys[j], "isreply", false);
            this.$set(value[i].replys[j], "ishot", 1);
          }
        }
      }
    },
    totalCommentList (value) {
      if (value.length !== 0) {
        for (let i in value) {
          this.$set(value[i], "isreply", false);
          this.$set(value[i], "ishot", 0);
          for (let j in value[i].replys) {
            this.$set(value[i].replys[j], "isreply", false);
            this.$set(value[i].replys[j], "ishot", 0);
          }
        }
      }
    }
  },
  computed: {
    ...mapState("PersonalStore", ["userdetailList"]), //为了获取当前登陆用户的头像
    ...mapState("WriteDataStore", ["writeData"]),
    ...mapState("HomeDataStore", ["checkform"]),
    ...mapState("NewTravelStore", ["findtreveldetail"]),
    ...mapState("CheckDataStore", ["wantNum", "have"])
  },
  methods: {
    handleScroll () {
      let _this = this;
      //获取监听的正文dom对象
      let monitoArr = document.querySelectorAll(".monitorTarget");
      //对NodeList应用Array的方法
      monitoArr = Array.prototype.slice.call(monitoArr);
      //找到首个top大于0的 （首个内容完整的）
      let naviIndex = monitoArr.findIndex(targetEle => {
        //获得dom的矩形区域
        let rect = targetEle.getBoundingClientRect();
        return rect.top > 0;
      });
      //获取监听的右侧目录dom对象
      let naviArr = document.querySelectorAll(".naviTarget");
      naviArr = Array.prototype.slice.call(naviArr);
      naviArr.forEach((targetNavi, index) => {
        if (index === naviIndex) {
          targetNavi.children[0].children[1].classList.add("checked-ball");
          targetNavi.children[1].classList.add("checked-text");
          if (naviArr[index].offsetTop > 285) {
            _this.$refs["elscrollbar"].$refs["wrap"].scrollTop =
              naviArr[index].offsetTop - 285;
          }
        } else {
          targetNavi.children[0].children[1].classList.remove("checked-ball");
          targetNavi.children[1].classList.remove("checked-text");
        }
      });
    },
    // 返回页面顶部的方法
    returnToTop () {
      this.showReturnTop = false;
      window.scrollTo(0, 0);
    },
    //用户反馈
    userFeedback () {
      if (this.userId === undefined) {
        this.$router.push({ path: `/minelog/login` });
        this.$eventHub.$emit("pageChange", "login");
        return;
      }
      this.userFeedbackVisible = true;
    },
    ...mapMutations("WriteDataStore", ["bottomMutation"]),
    changeLike (details) {
      // 如果用户没有登录直接返回到登录页面
      if (this.$cookie.get("userInfo_userId")) {
        adoptComment({
          userId: this.$cookie.get("userInfo_userId"),
          commentId: details.item.id
        }).then(json => {
          //返回后查询所有数据
          if (json.respCode === 100) {
            //刷新热门评论
            this.queryComment({
              type: 2, //查询热门评论
              dataTypeId: 14,
              dataId: this.form.id,
              rows: 3, //查询top3的热门评论
              page: 1,
              userId: this.$cookie.get("userInfo_userId")
            });
            //刷新所有评论
            if (this.hasTriggerInfinate) {
              this.queryComment({
                type: 1, //查询所有评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: this.lastTotal,
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
            } else {
              this.queryComment({
                type: 1, //查询所有评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: 10,
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
            }
          }
        });
      } else {
        //跳转至登录页
        this.$router.push({ path: `/minelog/login` });
        this.$eventHub.$emit("pageChange", "login");
      }
    },
    loadAllList () {
      //查询全部评论列表
      //开启无限滚动loading
      this.infiniteLoading = true;
      this.queryComment(
        {
          type: 1, //查询所有评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: this.originRows,
          page: 1,
          userId: this.$cookie.get("userInfo_userId"),
          loadingFlase: true //禁止loading
        },
        "loadAllList"
      );
    },
    queryComment (queryForm, queryEntrance) {
      queryComment(queryForm).then(json => {
        if (json.respCode === 100) {
          if (queryForm.type == 1) {
            //检索全部评论
            this.lastTotal = json.data.length;
            let listTotal = json.total;
            if (listTotal > 0) {
              this.contentShow = true;
            } else {
              this.contentShow = false;
            }
            //如果是通过无线加载请求的查询
            if (queryEntrance === "loadAllList") {
              //关闭无限滚动loading
              this.infiniteLoading = false;
              this.originRows += 10; //每一次比上一次多查询10条数据
              //  this.originPage++; //增加页数
              this.totalCommentList = json.data;
              //用户请求的总的评论条数
              let DownloadTotal = queryForm.rows;
              if (DownloadTotal >= listTotal) {
                //已经没有更多数据的情况下: 显示所有评论已读，关闭无限滚动
                this.showAllHasRead = true;
                this.stopSrearchAllList = true;
                //  this.originPage = 1;
                this.scrollDisabled = true;
              } else {
                this.showAllHasRead = false;
                this.scrollDisabled = false;
              }
            } else {
              //初始进入页面或者点赞等其他情况下的请求
              this.totalCommentList = json.data;
            }
          } else if (queryForm.type == 2) {
            //检索热门评论
            this.hotCommentList = json.data;
          }
        }
      });
    },
    //发表评论
    releaseComment () {
      let descrip = this.commentText.replace(/\n/g, "");
      //如果全是空格或者文本为空
      if (this.commentText.match(/^[ ]*$/) || !this.commentText) {
        this.showTipText = true;
        return;
      } else if (descrip.trim() == "") {
        this.showTipText = true;
        return;
      } else {
        saveComment({
          id: "",
          userId: this.$cookie.get("userInfo_userId"),
          state: 2,
          comment: this.commentText,
          dataTypeId: 14,
          dataType: 14,
          dataId: this.form.id,
          dataName: this.form.name,
          flag: 1,
          srcComment: ""
        }).then(json => {
          if (json.respCode === 100) {
            //清空上次评论的内容
            this.commentText = "";
            //发表评论成功后刷新全部评论列表
            //如果触发过无限搜索
            if (this.hasTriggerInfinate) {
              this.queryComment({
                type: 1, //查询全部评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: this.originRows + 1,
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
            } else {
              this.queryComment({
                type: 1, //查询全部评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: 10,
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
            }
          }
        });
      }
    },
    ...mapActions("NewTravelStore", [
      "findtrevelNotesdetail",
      "findTravelDetailOld"
    ]),
    ...mapActions("CheckDataStore", [
      "getCheckWantgo",
      "getAddWantGo",
      "getDeleteWantGo"
    ]),
    // ...mapActions("DetailsStore", ["saveFeedbackactions"]),
    collapseToggle () {
      this.collapse = !this.collapse;
    },
    nodeClickPatch (showTarget) {
      let naviArr = document.querySelectorAll(".naviTarget");
      naviArr = Array.prototype.slice.call(naviArr);
      naviArr.forEach(targetNavi => {
        targetNavi.children[0].children[1].classList.remove("checked-ball");
        targetNavi.children[1].classList.remove("checked-text");
      });
      this.$refs[showTarget][0].children[0].children[1].classList.add(
        "checked-ball"
      );
      this.$refs[showTarget][0].children[1].classList.add("checked-text");
    },
    nodeClick (e, items, index) {
      this.naviChildChecked = "~";
      this.naviChecked = index;
      window.scrollTo(0, this.$refs[`node${index}`][0].offsetTop);
      this.nodeClickPatch(`navi${index}`);
    },
    nodechildClick (e, index, j) {
      this.naviChecked = "~";
      this.naviChildChecked = `${index}${j}`;
      window.scrollTo(0, this.$refs[`nodechild${index}${j}`][0].offsetTop);
      this.nodeClickPatch(`navi${index}${j}`);
    },
    isHeart () {
      let loginUserInfo = this.$cookie.get("userInfo_userId");
      //如果是已经登录状态则在想去和不想去之间尽心状态切换
      //如果是没有登录则跳转至登录页面
      if (loginUserInfo) {
        let data = {
          userId: this.$cookie.get("userInfo_userId"),
          dataId: this.id,
          dataTypeId: 14
        };
        if (this.have == 0) {
          this.getAddWantGo(data);
        } else if (this.have == 1) {
          this.getDeleteWantGo({
            data: [
              {
                userId: this.$cookie.get("userInfo_userId"),
                dataId: this.id,
                dataTypeId: 14
              }
            ]
          });
        }
      } else {
        //跳转至登录页
        this.$router.push({ path: `/minelog/login` });
        this.$eventHub.$emit("pageChange", "login");
      }
    },
    importTransform () {
      return import("@/assets/images/travel/cover.png");
    },
    importTransform2 () {
      return import("@/assets/images/person/avatar-default.png");
    },
    imageMapping (value) {
      if (this.imageOfType[value]) {
        return this.imageOfType[value];
      }
      return import("@/assets/images/icons/type/cannotmiss.png");
    },
    getScrollTop () {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    //文档的总高度
    getScrollHeight () {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    getWindowHeight () {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    //用户反馈弹窗确认
    userFeedbackonClick () {
      //如果全是空格或者文本为空
      if (this.feedbackContent.match(/^[ ]*$/) || !this.feedbackContent) {
        return;
      } else {
        saveFeedback({
          userId: this.$cookie.get("userInfo_userId"),
          feedbackContent: this.feedbackContent
        }).then(json => {
          if (json.respCode === 100) {
            this.feedbackContent = "";
            this.userFeedbackVisible = false;
            this.$message.success("发送成功");
          } else {
            this.$message.error("发送失败");
          }
        });
      }
    },
    //回复评论
    replyRelease (details) {
      if (details.flag === "1级") {
        this.obj = {
          dataTypeId: 14,
          dataId: this.id,
          dataName: this.form.name,
          comment: details.comment,
          userId: this.$cookie.get("userInfo_userId"),
          replyId: details.replyId,
          replyUserId: details.contents.userId,
          flag: 1
        };
      } else if (details.flag === "2级") {
        this.obj = {
          dataTypeId: 14,
          dataId: this.id,
          dataName: this.form.name,
          comment: details.comment,
          userId: this.$cookie.get("userInfo_userId"),
          replyId: details.contents.replyId,
          replyUserId: details.contents.userId,
          flag: 1
        };
      }
      replyComment(this.obj).then(json => {
        if (json.respCode === 100) {
          this.$message.success("回复成功！");
          details.contents.isreply = false;
          //刷新热门评论
          this.queryComment({
            type: 2, //查询热门评论
            dataTypeId: 14,
            dataId: this.form.id,
            rows: 3, //查询top3的热门评论
            page: 1,
            userId: this.$cookie.get("userInfo_userId")
          });
          if (this.hasTriggerInfinate) {
            this.queryComment({
              type: 1, //查询全部评论
              dataTypeId: 14,
              dataId: this.form.id,
              rows: this.originRows + 1,
              page: 1,
              userId: this.$cookie.get("userInfo_userId")
            });
          } else {
            this.queryComment({
              type: 1, //查询全部评论
              dataTypeId: 14,
              dataId: this.form.id,
              rows: 10,
              page: 1,
              userId: this.$cookie.get("userInfo_userId")
            });
          }
        } else {
          this.$message.error("回复失败！");
        }
      });
    },
    isreply (data) {
      // this.$nextTick(() => {
      // this.$refs.comment.comment = "";
      // });
      if (this.$cookie.get("userInfo_userId")) {
        if (data.ishot === 1) {
          this.list = this.hotCommentList;
        } else {
          this.list = this.totalCommentList;
        }
        //首次打开弹出框
        if (data.childindex !== undefined) {
          for (var i = 0; i < this.list.length; i++) {
            this.list[i].isreply = false;
            if (this.list[i].replys) {
              for (var j = 0; j < this.list[i].replys.length; j++) {
                if (
                  data.index === i &&
                  data.childindex === j &&
                  !this.list[i].replys[j].isreply
                ) {
                  this.list[i].replys[j].isreply = true;
                } else {
                  this.list[i].replys[j].isreply = false;
                }
              }
            }
          }
        } else {
          for (var i = 0; i < this.list.length; i++) {
            if (data.index === i && !this.list[i].isreply) {
              this.list[i].isreply = true;
            } else {
              this.list[i].isreply = false;
            }
            if (this.list[i].replys) {
              for (var j = 0; j < this.list[i].replys.length; j++) {
                this.list[i].replys[j].isreply = false;
              }
            }
          }
        }
        //相同的弹出框
        // if (data.childindex !== undefined) {
        //   for (var i = 0; i < this.list.length; i++) {
        //     if (this.list[i].replys) {
        //       for (var j = 0; j < this.list[i].replys.length; j++) {
        //         if (i === data.index && j === data.childindex) {
        //           this.list[data.index].replys[
        //             data.childindex
        //           ].isreply = !data.isreply;
        //           continue;
        //         } else {
        //           this.list[data.index].replys[data.childindex].isreply =
        //             false;
        //         }
        //       }
        //     }
        //   }
        // } else {
        //   for (var i = 0; i < this.list.length; i++) {
        //     if (i === data.index) {
        //       this.list[data.index].isreply = !data.isreply;
        //       continue;
        //     } else {
        //       this.list[data.index].isreply = false;
        //     }
        //   }
        // }
      } else {
        //跳转至登录页
        this.$router.push({ path: `/minelog/login` });
        this.$eventHub.$emit("pageChange", "login");
      }
    },
    commentDelete (details) {
      this.$confirm(
        `${
        details.childindex === undefined
          ? "删除评论，评论下全部回复内容将一并删除。"
          : "确定删除该条评论？"
        }`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }
      )
        .then(() => {
          removeComment({
            userId: this.$cookie.get("userInfo_userId"),
            id: details.item.id
          }).then(json => {
            //返回后查询所有数据
            if (json.respCode === 100) {
              //刷新热门评论
              this.queryComment({
                type: 2, //查询热门评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: 3, //查询top3的热门评论
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
              //刷新所有评论
              if (this.hasTriggerInfinate) {
                this.queryComment({
                  type: 1, //查询所有评论
                  dataTypeId: 14,
                  dataId: this.form.id,
                  rows: this.lastTotal,
                  page: 1,
                  userId: this.$cookie.get("userInfo_userId")
                });
              } else {
                this.queryComment({
                  type: 1, //查询所有评论
                  dataTypeId: 14,
                  dataId: this.form.id,
                  rows: 10,
                  page: 1,
                  userId: this.$cookie.get("userInfo_userId")
                });
              }
            }
          });
        })
        .catch(() => { });
    }
  },
  created () {
    this.id = this.$route.params.id;
    this.userId = this.$cookie.get("userInfo_userId");
    this.form = this.checkform;
    //调用原来的info/getTravelNoteInfoDetail
    if (this.id.indexOf("old") !== -1) {
      this.id = this.id.substring(3, this.id.length);
      this.findTravelDetailOld({ id: this.id });
    } else if (this.id.indexOf("new") !== -1) {
      this.id = this.id.substring(3, this.id.length);
      this.findtrevelNotesdetail({ id: this.id });
    } else {
      // 从移动端过来
      this.findtrevelNotesdetail({ id: this.id });
    }
    this.getCheckWantgo({
      userId: this.$cookie.get("userInfo_userId"),
      dataId: this.id,
      dataTypeId: 14
    });
    this.$root.showWriteBall = true;
    this.$eventHub.$on("windowScroll", data => {
      //监测滚高度，等于0隐藏返回顶部按钮；否则显示隐藏按钮
      if (data.scrollTop === 0) {
        this.showReturnTop = false;
      } else {
        this.showReturnTop = true;
      }
      this.returnTopBottomValue =
        data.scrollBottom > 400 ? "87px" : `${data.fixBottom + 57}px`;
      this.useFeedbackValue =
        data.scrollBottom > 400 ? "30px" : `${data.fixBottom}px`;
      if (data.fixBottom >= 429) {
        if (this.stopSrearchAllList) {
          return;
        } else {
          this.hasTriggerInfinate = true; //触发了无限滚动
          this.loadAllList();
        }
      }
      if (data.scrollTop > 950) {
        if (data.scrollBottom < 100) {
          this.tNaviStyle = {
            position: "fixed",
            bottom: `${(document.documentElement.clientHeight ||
              document.body.clientHeight) - 420}px`,
            left: `${this.$refs.tNavi.offsetLeft}px`
          };
          this.returnTopLeftValue = `${this.$refs.tNavi.offsetLeft}px`;
          this.feedbackTopLeftValue = `${this.$refs.tNavi.offsetLeft + 4}px`;
        } else {
          this.tNaviStyle = {
            position: "fixed",
            top: "0px",
            left: `${this.$refs.tNavi.offsetLeft}px`
          };
          this.returnTopLeftValue = `${this.$refs.tNavi.offsetLeft}px`;
          this.feedbackTopLeftValue = `${this.$refs.tNavi.offsetLeft + 4}px`;
        }
      } else {
        this.tNaviStyle = {};
        this.returnTopLeftValue = `${this.$refs.tNavi.offsetLeft}px`;
        this.feedbackTopLeftValue = `${this.$refs.tNavi.offsetLeft + 4}px`;
      }
    });
  },
  destroyed () {
    this.$root.showWriteBall = false;
    window.localStorage.setItem("state", "");
  }
};
</script>
<style lang="less">
@import "~@/lesses/main/travel/preview.less";
</style>
